/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUserRoleType } from './TeamUserRoleType.js';
import {
    TeamUserRoleTypeFromJSON,
    TeamUserRoleTypeFromJSONTyped,
    TeamUserRoleTypeToJSON,
} from './TeamUserRoleType.js';

/**
 * 
 * @export
 * @interface UpdateTeamUserRequest
 */
export interface UpdateTeamUserRequest {
    /**
     * 
     * @type {TeamUserRoleType}
     * @memberof UpdateTeamUserRequest
     */
    role?: TeamUserRoleType;
}

/**
 * Check if a given object implements the UpdateTeamUserRequest interface.
 */
export function instanceOfUpdateTeamUserRequest(value: object): boolean {
    return true;
}

export function UpdateTeamUserRequestFromJSON(json: any): UpdateTeamUserRequest {
    return UpdateTeamUserRequestFromJSONTyped(json, false);
}

export function UpdateTeamUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] == null ? undefined : TeamUserRoleTypeFromJSON(json['role']),
    };
}

export function UpdateTeamUserRequestToJSON(value?: UpdateTeamUserRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': TeamUserRoleTypeToJSON(value['role']),
    };
}

